// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from list-unordered.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ListUnorderedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm13 1a1 1 0 0 1 .117 1.993L15 15H7a1 1 0 0 1-.117-1.993L7 13h8ZM2 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm13 1a1 1 0 0 1 .117 1.993L15 9H7a1 1 0 0 1-.117-1.993L7 7h8ZM2 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm13 1a1 1 0 0 1 .117 1.993L15 3H7a1 1 0 0 1-.117-1.993L7 1h8Z"
      />
    </svg>
  );
}
